export enum WorkspaceState {
  Online = 'ONLINE',
  Offline = 'OFFLINE',
  NOT_MONITORED = 'NOT_MONITORED'
}
